/* Peachy Earth — keep the Add to Cart button price in sync with the
   subscription (selling plan) selection made in the subscriptions widget.
   Works by pointing the theme's reactive variant price at the selected
   selling plan allocation price (from Shopify's own product data). */
(function () {
  'use strict';

  function getAlpineData(form) {
    if (!window.Alpine) return null;
    var root = form;
    while (root && !root.hasAttribute('x-data')) root = root.parentElement;
    if (!root) return null;
    try { return window.Alpine.$data(root); } catch (e) { return null; }
  }

  function sync() {
    var form = document.querySelector('form[action*="/cart/add"].shopify-product-form');
    var widget = document.querySelector('.essub-campaign-widget');
    if (!form || !widget) return;
    var d = getAlpineData(form);
    if (!d || !d.currentVariant) return;
    var cv = d.currentVariant;

    /* remember the variant's true one-time price before any adjustment */
    if (typeof cv._peBasePrice === 'undefined') cv._peBasePrice = cv.price;

    var sp = form.querySelector('input[name="selling_plan"]');
    var spId = sp && sp.value ? parseInt(sp.value, 10) : null;

    var target = cv._peBasePrice;
    if (spId && cv.selling_plan_allocations) {
      for (var i = 0; i < cv.selling_plan_allocations.length; i++) {
        var a = cv.selling_plan_allocations[i];
        if (a.selling_plan_id === spId) { target = a.price; break; }
      }
    }
    if (cv.price !== target) d.currentVariant.price = target;
  }

  var t = null;
  function queueSync() {
    clearTimeout(t);
    t = setTimeout(sync, 120);
  }

  function init() {
    var widget = document.querySelector('.essub-campaign-widget');
    if (!widget) return false;
    document.addEventListener('click', queueSync, true);
    document.addEventListener('change', queueSync, true);
    new MutationObserver(queueSync).observe(widget.parentElement || widget, { subtree: true, childList: true, attributes: true });
    /* safety net: cheap periodic re-check */
    setInterval(sync, 1000);
    sync();
    return true;
  }

  /* the subscriptions widget is injected by the app after page load —
     poll for up to 60s before giving up */
  var tries = 0;
  var boot = setInterval(function () {
    tries++;
    if (init() || tries > 120) clearInterval(boot);
  }, 500);
})();
